import React from "react";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import ReactTable from "react-table-6";
import { Slider } from '@material-ui/core';
import CircularProgress from "@material-ui/core/CircularProgress";
import { Save as SaveIcon, PictureAsPdf as PdfIcon, Visibility as VisibilityIcon } from "@material-ui/icons";
import { numberToFormat } from "../../Utils";

class FactureReaDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { puHt, quantity, amountHt, totalht, tva, disableButton } = this.props;
    const data = [
      {
        actType: (
          <div className="titleDevisRea">1. Préparation du chantier:</div>
        ),
        heures: <div className="titleDevisRea"></div>,
      },
      {
        actType: "1.1. Inspections Communes avec les entreprises",
        heures: 0,
      },
      {
        actType: "1.2. Harmonisation des P.P.S.P.S./Mise à jour du P.G.C",
        heures: 0,
      },
      {
        actType: "1.3. Tenue Registre Journal",
        heures: 0,
      },
      {
        actType: <div className="titleDevisRea">2. Travaux:</div>,
        heures: 0,
      },
      {
        actType: "2.1. Visites de chantier",
        heures: 0,
      },
      {
        actType: "2.2. Réunions de C.I.S.S.C.T",
        heures: 0,
      },
      {
        actType: "2.3. Participation au rendez-vous de chantier",
        heures: 0,
      },
      {
        actType: (
          <div className="titleDevisRea">3. Réception des travaux:</div>
        ),
        heures: 0,
      },
      {
        actType: "3.1. Récolement des pièces liées au D.I.U.O",
        heures: 0,
      },
      {
        actType: "3.2. Mise à jour du D.I.U.O.final",
        heures: 0,
      },
      {
        actType: "3.3. Diffusion du P.G.C et du D.I.U.O",
        heures: 0,
      },
      {
        actType: (
          <div className="titleDevisRea">TOTAL HT :</div>
        ),
        heures: "",
        ht: "",
      },
    ];
    const columns = [
      {
        Header: "PHASE REALISATION",

        columns: [
          {
            Header: "Actes Types",
            accessor: "actType",
          },
          {
            Header: "Quantité",
            accessor: "quantite",
            width: 120,
            Cell: (props) => {
              if (
                props.row._index === 0 ||
                props.row._index === 4 ||
                props.row._index === 8 ||
                props.row._index === 12
              )
                return <p>{""}</p>;
              else
                return (
                  <input
                    style={{
                      border: "none",
                      height: "100%",
                      width: "100%",
                      textAlign: "center",
                      fontSize: "15px",
                    }}
                    value={quantity[this.props.checkIndex(props.row._index)]}
                    name={"quantity"}
                    onChange={(event) =>
                      this.props.handleChange(event, props.row._index)
                    }
                  />
                );
            },
          },
          {
            Header: "PU HT",
            accessor: "puht",
            width: 70,
            Cell: (props) => {
              if (
                props.row._index === 0 ||
                props.row._index === 4 ||
                props.row._index === 8 ||
                props.row._index === 12
              )
                return "";
              else
                return (
                  <span style={{ display: "block", textAlign: "center" }}>{puHt}</span>
                );
            },
          },
          {
            Header: "Montant HT",
            accessor: "ht",
            width: 120,
            Cell: (props) => {
              if (
                props.row._index === 12
              )
                return <span style={{ display: "block", textAlign: "center" }}>{numberToFormat(totalht)}</span>
              if (
                props.row._index === 0 ||
                props.row._index === 4 ||
                props.row._index === 8
              )
                return <p>{""}</p>;
              else
                return (
                  <span style={{ display: "block", textAlign: "center" }}>{numberToFormat(amountHt[this.props.checkIndex(props.row._index)])}</span>
                );
            },
          },
        ],
      },
    ];
    return (
      <div className="facture-readetail">
        <ReactTable data={data} columns={columns} defaultPageSize={13} />
        <div className='tva'>
          <label>TVA : </label>
          <Slider value={tva} style={{ marginLeft: "7px" }} step={0.5} min={1} max={35} onChange={(_, value) => this.props.handleChangeTva(value)} />
          <input value={tva} style={{ width: "25px", height: "15px", margin: "0 5px 0 7px" }} onChange={(event) => this.props.handleChangeTva(event.target.value !== "" ? parseFloat(event.target.value) : event.target.value)} /> %
        </div>
        <div className="group-btn">
          {disableButton && (
            <CircularProgress className="spinner" color="inherit" />
          )}
          <Button
            className="gen-btn"
            variant="contained"
            color="primary"
            startIcon={<SaveIcon />}
            disabled={disableButton}
            onClick={this.props.handleSaveClick}
          >
            Enregistrer
          </Button>
          <Button
            className="gen-btn"
            variant="contained"
            color="primary"
            startIcon={<PdfIcon />}
            disabled={disableButton}
            onClick={this.props.handleGenClick}
          >
            Générer
          </Button>
          <Button
            className="gen-btn"
            variant="contained"
            color="primary"
            startIcon={<VisibilityIcon />}
            disabled={disableButton}
            onClick={this.props.handleShowPdf}
          >
            Afficher
          </Button>
          <Button
            className="gen-btn"
            disabled={disableButton}
            variant="contained"
            color="primary"
            onClick={this.props.handleResetQantity}
          >
            Annuler
          </Button>
        </div>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  facture: state.facture.items,
  nfacvalue: state.facture.nfacvalue,
  dossierValue: state.devis.dossierValue,
  dossier: state.dossier.items,
  itemNdossier: state.echeances.itemNdossier,
  deviscon: state.devis.deviscon,
  contact: state.contact.items
});
export default connect(mapStateToProps)(FactureReaDetail);